angular.module('wbDirectives').directive 'confirm', ->
  restrict: 'A'
  require: '?ngModel'
  link: ($scope, elem, attrs, ctrl) ->
    return unless ctrl

    setValidity = (value1, value2) ->
      if value1 is value2
        ctrl.$setValidity('confirm', true)
      else
        ctrl.$setValidity('confirm', false)

    $scope.$watch attrs.confirm, (value) ->
      setValidity(ctrl.$modelValue, value)

    ctrl.$viewChangeListeners.push ->
      setValidity(ctrl.$modelValue, $scope.$eval(attrs.confirm))
